import {
  AcademicCapIcon as AcademicCapIconSolid,
  KeyIcon as KeyIconSolid,
  BoltIcon as BoltIconSolid,
  PlayIcon as PlayIconSolid,
  QuestionMarkCircleIcon as QuestionMarkCircleIconSolid,
  CommandLineIcon as CommandLineIconSolid,
  PhotoIcon as PhotoIconSolid,
  PhotoIcon as PhotoIconOutline,
} from '@heroicons/react/20/solid';

import {
  AcademicCapIcon as AcademicCapIconOutline,
  KeyIcon as KeyIconOutline,
  BoltIcon as BoltIconOutline,
  PlayIcon as PlayIconOutline,
  QuestionMarkCircleIcon as QuestionMarkCircleIconOutline,
  CommandLineIcon as CommandLineIconOutline,
} from '@heroicons/react/24/outline';

export const SectionIcons = {
  AcademicCapIcon: {
    solid: AcademicCapIconSolid,
    outline: AcademicCapIconOutline,
  },
  KeyIcon: {
    solid: KeyIconSolid,
    outline: KeyIconOutline,
  },
  BoltIcon: {
    solid: BoltIconSolid,
    outline: BoltIconOutline,
  },
  PlayIcon: {
    solid: PlayIconSolid,
    outline: PlayIconOutline,
  },
  QuestionMarkCircleIcon: {
    solid: QuestionMarkCircleIconSolid,
    outline: QuestionMarkCircleIconOutline,
  },
  CommandLineIcon: {
    solid: CommandLineIconSolid,
    outline: CommandLineIconOutline,
  },
  PhotoIcon: {
    solid: PhotoIconSolid,
    outline: PhotoIconOutline,
  },
};

export type SectionIconsType = keyof typeof SectionIcons;

type SectionIconProps = {
  icon: SectionIconsType;
  type?: 'solid' | 'outline';
};

export function getSectionIcon(icon: string, type: 'solid' | 'outline') {
  if (icon in SectionIcons) {
    return SectionIcons[icon as SectionIconsType][type];
  }

  return SectionIcons['AcademicCapIcon'][type];
}

const SectionIcon = ({ icon, type = 'solid' }: SectionIconProps) => {
  const Icon = getSectionIcon(icon, type);
  return <Icon className="w-4 h-4 text-base-content shrink-0" />;
};

export default SectionIcon;
